import { render } from "./FooterUser.vue?vue&type=template&id=a3e11d5c"
import script from "./FooterUser.vue?vue&type=script&lang=js"
export * from "./FooterUser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__